"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const KevinBadRequestError_1 = require("../errors/KevinBadRequestError");
const KevinUnauthorizedError_1 = require("../errors/KevinUnauthorizedError");
const KevinError_1 = require("../errors/KevinError");
const package_json_1 = require("../../package.json");
class KevinApiClient {
    constructor(clientId, clientSecret, clientOptions) {
        this._clientId = clientId;
        this._clientSecret = clientSecret;
        this._metadataHeaders = clientOptions === null || clientOptions === void 0 ? void 0 : clientOptions.metadata;
        this._baseUrl = (clientOptions === null || clientOptions === void 0 ? void 0 : clientOptions.baseUrl) || 'https://api.kevin.eu/platform/v0.3';
    }
    sendRequest(path, method, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = Object.assign(Object.assign(Object.assign(Object.assign({}, this.getAuthorizationHeaders(options === null || options === void 0 ? void 0 : options.bearerToken)), this.metadataHeaders), KevinApiClient.clientHeaders), options === null || options === void 0 ? void 0 : options.headers);
            const url = this.getUrl(path, options === null || options === void 0 ? void 0 : options.pathParameters, options === null || options === void 0 ? void 0 : options.queryParameters);
            return (0, axios_1.default)({ method, url, data: options === null || options === void 0 ? void 0 : options.body, headers, responseType: 'json' })
                .then(response => response.data)
                .catch(error => {
                var _a, _b;
                const { response } = error;
                switch (response.status) {
                    case 401:
                        throw new KevinUnauthorizedError_1.default();
                    case 400:
                        const err = response.data.error;
                        throw new KevinBadRequestError_1.default(err.code, err.name, err.description, (_a = response.data) === null || _a === void 0 ? void 0 : _a.data);
                    default:
                        throw new KevinError_1.default(response.status, response.statusText, ((_b = response.data) === null || _b === void 0 ? void 0 : _b.data) || response.data);
                }
            });
        });
    }
    appendQueryParameters(url, parameters) {
        const newUrl = new URL(url);
        for (const key in parameters) {
            const parameter = parameters[key];
            if (Array.isArray(parameter)) {
                parameter.forEach((element) => {
                    newUrl.searchParams.append(key, element);
                });
            }
            else {
                newUrl.searchParams.append(key, String(parameters[key]));
            }
        }
        return newUrl.toString();
    }
    getUrl(path, pathParameters = {}, queryParameters = {}) {
        let url = `${this._baseUrl}${path}`;
        if (Object.keys(pathParameters).length > 0) {
            url = KevinApiClient.insertPathParameters(url, pathParameters);
        }
        if (Object.keys(queryParameters).length > 0) {
            url = this.appendQueryParameters(url, queryParameters);
        }
        return url;
    }
    getAuthorizationHeaders(token) {
        const headers = {
            'Client-Id': this._clientId,
            'Client-Secret': this._clientSecret,
        };
        if (token) {
            headers.Authorization = `Bearer ${token}`;
        }
        return headers;
    }
    get metadataHeaders() {
        if (this._metadataHeaders === undefined) {
            return {};
        }
        return {
            'Plugin-Version': this._metadataHeaders.pluginVersion,
            'Plugin-Platform-Version': this._metadataHeaders.pluginPlatformVersion,
            'Plugin-Platform': this._metadataHeaders.pluginPlatform,
        };
    }
    static get clientHeaders() {
        return {
            Library: package_json_1.name,
            'Library-Version': package_json_1.version,
        };
    }
    static insertPathParameters(url, parameters) {
        for (const parameter in parameters) {
            url = url.replace(`{${parameter}}`, parameters[parameter]);
        }
        return url;
    }
}
exports.default = KevinApiClient;
